module.exports = __webpack_public_path__ + "img/8.510c0db0.png";